/**
 * @file Route: webinarsingle
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import Header from "components/Header/Pro";
import "components/Nav";
import "components/When";
import "components/Card";
import "components/Speaker";
import initDialogVideo from "components/Dialog/Video";
import SliderVideos from "components/Slider/Videos";
import { listen } from "@olmokit/dom";
import "./index.scss";

console.log("Route webinarsingle/index.js mounted.");

Header();

initDialogVideo();
SliderVideos(".related:");

listen("click", "[data-horsa]", (event) => {});

